import "./App.css";
import 'react-quill/dist/quill.snow.css'; 
import 'quill/dist/quill.snow.css'; 

import { BrowserRouter } from "react-router-dom";
import Body from "./components/Body";

export default function App() {
  return (
    <BrowserRouter>
      <Body />
    </BrowserRouter>
  );
}
 